import CampaignManager, { CampaignLevel } from './CampaignManager';

export default class CampaignLevelCompleteModal {
    private campaignManager: CampaignManager;
    private container: HTMLDivElement | null = null;
    private onContinue: (() => void) | null = null;
    private onSelectLevel: ((level: CampaignLevel) => void) | null = null;

    constructor(campaignManager: CampaignManager) {
        this.campaignManager = campaignManager;
    }

    public show(level: CampaignLevel, onContinue: () => void, onSelectLevel: (level: CampaignLevel) => void): void {
        this.onContinue = onContinue;
        this.onSelectLevel = onSelectLevel;
        this.createUI(level);
    }

    public hide(): void {
        if (this.container && this.container.parentElement) {
            this.container.parentElement.removeChild(this.container);
        }
        this.container = null;
    }

    private createUI(level: CampaignLevel): void {
        // Remove existing UI if present
        this.hide();

        this.container = document.createElement('div');
        this.container.id = 'campaign-level-complete-modal';
        this.container.style.cssText = `
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.95);
            z-index: 10001;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: white;
            font-family: 'Arial', sans-serif;
        `;

        // Modal content
        const modalContent = document.createElement('div');
        modalContent.style.cssText = `
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 20px;
            padding: 40px;
            max-width: 600px;
            width: 90%;
            text-align: center;
            box-shadow: 0 20px 60px rgba(0,0,0,0.5);
        `;

        // Title
        const title = document.createElement('h1');
        title.textContent = 'Level Complete!';
        title.style.cssText = `
            font-size: 48px;
            margin-bottom: 20px;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
            color: #FFD700;
        `;
        modalContent.appendChild(title);

        // Level info
        const levelInfo = document.createElement('div');
        levelInfo.textContent = `${level.name} - World ${level.worldId + 1}`;
        levelInfo.style.cssText = `
            font-size: 24px;
            margin-bottom: 30px;
            opacity: 0.9;
        `;
        modalContent.appendChild(levelInfo);

        // Progress update
        const progress = this.campaignManager.getProgress();
        const progressText = document.createElement('div');
        progressText.textContent = `Campaign Progress: ${progress.completed}/${progress.total} levels`;
        progressText.style.cssText = `
            font-size: 18px;
            margin-bottom: 40px;
            opacity: 0.8;
        `;
        modalContent.appendChild(progressText);

        // Buttons container
        const buttonsContainer = document.createElement('div');
        buttonsContainer.style.cssText = `
            display: flex;
            gap: 20px;
            justify-content: center;
            flex-wrap: wrap;
        `;

        // Continue to next level button
        const nextLevel = this.campaignManager.getCurrentLevel();
        const hasNextLevel = nextLevel && this.campaignManager.advanceToNextLevel();
        
        if (hasNextLevel) {
            const continueButton = document.createElement('button');
            continueButton.textContent = 'Continue to Next Level';
            continueButton.style.cssText = `
                padding: 15px 30px;
                font-size: 20px;
                background: #4CAF50;
                color: white;
                border: none;
                border-radius: 8px;
                cursor: pointer;
                transition: all 0.2s;
                font-weight: bold;
            `;
            continueButton.onmouseenter = () => {
                continueButton.style.background = '#45a049';
                continueButton.style.transform = 'scale(1.05)';
            };
            continueButton.onmouseleave = () => {
                continueButton.style.background = '#4CAF50';
                continueButton.style.transform = 'scale(1)';
            };
            continueButton.onclick = () => {
                if (this.onContinue) {
                    this.onContinue();
                }
                this.hide();
            };
            buttonsContainer.appendChild(continueButton);
        }

        // Level select button
        const selectButton = document.createElement('button');
        selectButton.textContent = 'Select Level';
        selectButton.style.cssText = `
            padding: 15px 30px;
            font-size: 20px;
            background: #2196F3;
            color: white;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s;
            font-weight: bold;
        `;
        selectButton.onmouseenter = () => {
            selectButton.style.background = '#0b7dda';
            selectButton.style.transform = 'scale(1.05)';
        };
        selectButton.onmouseleave = () => {
            selectButton.style.background = '#2196F3';
            selectButton.style.transform = 'scale(1)';
        };
        selectButton.onclick = () => {
            this.hide();
            if (this.onSelectLevel) {
                // The parent will handle showing the level select
                this.onSelectLevel(null as any); // Signal to show level select
            }
        };
        buttonsContainer.appendChild(selectButton);

        modalContent.appendChild(buttonsContainer);
        this.container.appendChild(modalContent);

        document.body.appendChild(this.container);
    }
}

